<template>

  <!-- BLOQUE 1: ACCIONES EXTERNAS (NODE JS / SCRIPTS) -->
  <v-sheet
    color="bgtopology"
    class="defaultCard cardReport mb-4"
    :class="smAndDown ? 'ma-1 pa-2' : 'pa-4 ma-4'"
    v-if="ROL === 'desarrollador'"
  >
    <v-row class="ma-0 align-center justify-space-between">
      <div>
        <h3 class="text-h6 font-weight-bold">Ejecución de Reportes Automatizados</h3>
      </div>
      <div class="d-flex ga-3">
        <v-btn color="primary" variant="elevated" @click="generarReporte">
          Generar reporte
        </v-btn>
        <v-btn color="success" variant="elevated" @click="enviarReporte">
          Enviar reporte
        </v-btn>
      </div>
    </v-row>
  </v-sheet>

  <!-- BLOQUE 2: CONSULTA DE DATOS CON FILTROS Y GENERACIÓN DE PDF -->
  <v-sheet
    color="bgtopology"
    class="defaultCard cardReport"
    :class="smAndDown ? 'ma-1 pa-2' : 'pa-4 ma-4'"
  >
    <v-row class="ma-0 mb-4 align-center">
      <h2 class="text-h5 font-weight-bold">Consulta y Filtros de Reporte</h2>
    </v-row>

    <!-- FORMULARIO DE FILTROS -->
    <div class="headerReport">
      <v-row>
        <v-col class="py-0" cols="12" sm="12" md="4">
          <h4 class="mb-2">{{ t("datePickers.dateini") }}</h4>
          <VueDatePicker
            class="mb-4"
            v-model="dateini"
            :model-type="STRING_GENERAL.time"
            :format="STRING_GENERAL.time"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="12" md="4">
          <h4 class="mb-2">{{ t("datePickers.datefin") }}</h4>
          <VueDatePicker
            class="mb-4"
            v-model="datefin"
            :model-type="STRING_GENERAL.time"
            :format="STRING_GENERAL.time"
          />
        </v-col>
        <v-col class="py-0" cols="12" sm="12" md="4">
          <h4 class="mb-2">Tipo</h4>
          <v-select
            v-model="familyType"
            density="compact"
            variant="outlined"
            :items="['Cliente', 'Acceso', 'Distribucion']"
          />
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2">
        <v-btn
          :disabled="!(datefin > dateini)"
          class="mb-6"
          color="btnSelect"
          @click="getItems"
        >
          {{ t("buttons.searchbtn") }}
        </v-btn>
        <v-col class="pa-0 mb-6 ml-4">
          <v-btn
            v-if="operability.length > 0"
            color="btnSelect"
            @click="exportToPdf"
          >
            Exportar a PDF
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div id="reportPDFid">
      <v-row justify="space-around" class="mt-5 pdfrow" v-if="showInfo">
        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          align-self="center"
          class="colreport mx-n4 my-6"
        >
          <v-sheet class="defaultCard" color="white">
            <h5 v-if="smAndDown" class="pl-4">
              {{ t("reportPage.subtitle1") }}
            </h5>
            <h3 v-else class="pl-4">{{ t("reportPage.subtitle1") }}</h3>
            <EasyDataTable
              v-if="operability.length > 0"
              header-class-name="headerColor"
              theme-color="#0e2f5a"
              :headers="headerOperabi"
              :items="operability"
              alternating
              show-index
              hide-footer
            >
              <template #item-ok="item"> {{ item.ok }}% </template>
              <template #item-alarm="item"> {{ item.alarm }}% </template>
              <template #item-alert="item"> {{ item.alert }}% </template>
              <template #item-down="item"> {{ item.down }}% </template>
              <template #item-ip="item">
                <v-btn
                  color="blue"
                  variant="plain"
                  @click="showDialog(item.ip, item.name, item.tipo)"
                >
                  {{ item.ip }}
                </v-btn>
              </template>
            </EasyDataTable>
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>
        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
          vertical
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          class="colreport2 mx-n4 my-6"
        >
          <v-sheet class="defaultCard" color="white">
            <ColumnChart
              class="pa-4 graphColumn3D"
              v-if="cantOK.length > 0"
              color="#000000"
              :title="t('reportPage.subtitle1')"
              name="Reporte"
              :firstArray="cantOK"
              :secondArray="cantALARM"
              :thridArray="cantALERT"
              :fourthArray="cantDOWN"
              :arrayIPs="arrayIPs"
            />
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>

        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
          v-if="showTenLAT"
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          v-if="showTenLAT"
          class="colreport3 mx-n4 my-6"
        >
          <v-sheet class="defaultCard" color="white">
            <h5 v-if="smAndDown" class="pl-4">Latencia</h5>
            <h3 v-else class="pl-4">Latencia</h3>
            <EasyDataTable
              v-if="latencyTen.length > 0"
              header-class-name="headerColor"
              theme-color="#0e2f5a"
              :headers="headerTenOperabi"
              :items="latencyTen"
              alternating
              show-index
              hide-footer
            >
              <template #item-latencia="item">
                {{ item.latencia.toFixed(2) }}ms
              </template>
              <template #item-ip="item">
                <v-btn
                  color="blue"
                  variant="plain"
                  @click="showDialog(item.ip, item.name, item.tipo)"
                >
                  {{ item.ip }}
                </v-btn>
              </template>
            </EasyDataTable>
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>
        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
          v-if="showQualityLap"
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          v-if="showQualityLap"
          class="colreport3 mx-n4 my-6"
        >
          <v-sheet class="defaultCard" color="white">
            <h5 v-if="smAndDown" class="pl-4">
              {{ t("reportPage.subtitle2") }}
            </h5>
            <h3 v-else class="pl-4">{{ t("reportPage.subtitle2") }}</h3>
            <EasyDataTable
              v-if="qualityLap.length > 0"
              header-class-name="headerColor"
              theme-color="#0e2f5a"
              :headers="headerQualLap"
              :items="qualityLap"
              alternating
              show-index
              hide-footer
            >
              <template #item-link_radio_rx="item">
                <v-row style="align-items: center !important">
                  <v-col cols="2" class="pa-0"
                    ><span> {{ item.link_radio_rx }} </span></v-col
                  >
                  <v-col cols="10">
                    <v-progress-linear
                      :model-value="-item.link_radio_rx"
                      height="10"
                      striped
                      :color="
                        item.link_radio_rx <= -85
                          ? '#ff0000'
                          : item.link_radio_rx <= -80
                          ? '#ff5050'
                          : item.link_radio_rx <= -75
                          ? '#ff9900'
                          : item.link_radio_rx <= -70
                          ? '#ffff00'
                          : item.link_radio_rx <= -65
                          ? '#ccff33'
                          : item.link_radio_rx <= -60
                          ? '#66ff33'
                          : item.link_radio_rx <= -55
                          ? '#40f7eb'
                          : item.link_radio_rx <= -50
                          ? '#3790fc'
                          : item.link_radio_rx <= -45
                          ? '#2d09f7'
                          : item.link_radio_rx <= -40
                          ? '#3b1ace'
                          : item.link_radio_rx <= -35
                          ? '#7009c4'
                          : item.link_radio_rx <= -33.6
                          ? '#8a079b'
                          : '#c8c8c8'
                      "
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <template #item-ip="item">
                <v-btn
                  color="blue"
                  variant="plain"
                  @click="showDialog(item.ip, item.name, item.tipo)"
                >
                  {{ item.ip }}
                </v-btn>
              </template>
            </EasyDataTable>
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>
        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
          v-if="showQualitySNRV || showQualitySNRH"
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          v-if="showQualitySNRV"
          class="colreport4 mx-n4 my-6"
        >
          <v-sheet class="defaultCard" color="white">
            <h5 v-if="smAndDown" class="pl-4">
              {{ t("reportPage.subtitleV") }}
            </h5>
            <h3 v-else class="pl-4">{{ t("reportPage.subtitleV") }}</h3>
            <EasyDataTable
              v-if="SNR_VERTI.length > 0"
              header-class-name="headerColor"
              theme-color="#0e2f5a"
              :headers="headerSNRVert"
              :items="SNR_VERTI"
              alternating
              show-index
              hide-footer
            >
              <template #item-vertical="item">
                <v-row
                  justify="space-between"
                  style="align-items: center !important"
                >
                  <v-col cols="2" class="pa-0"
                    ><span> {{ item.vertical }} </span></v-col
                  >
                  <v-col cols="10" class="pa-0 pr-2">
                    <v-progress-linear
                      :model-value="100"
                      height="10"
                      striped
                      :color="
                        item.vertical <= 15
                          ? '#FF0000'
                          : item.vertical <= 20
                          ? '#FFEE00'
                          : '#00FF00'
                      "
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <template #item-ip="item">
                <v-btn
                  color="blue"
                  variant="plain"
                  @click="showDialog(item.ip, item.name, item.tipo)"
                >
                  {{ item.ip }}
                </v-btn>
              </template>
            </EasyDataTable>
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>
        <v-divider
          :thickness="10"
          class="border-opacity-75 divider_color d-none d-sm-none d-md-flex"
          vertical
          v-if="showQualitySNRH && showQualitySNRV"
        ></v-divider>
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          v-if="showQualitySNRH"
          class="colreport5 mx-n4 my-6"
        >
          <v-sheet class="defaultCard card5" color="white">
            <h5 v-if="smAndDown" class="pl-4">
              {{ t("reportPage.subtitleH") }}
            </h5>
            <h3 v-else class="pl-4">{{ t("reportPage.subtitleH") }}</h3>
            <EasyDataTable
              v-if="SNR_HORIZ.length > 0"
              header-class-name="headerColor"
              theme-color="#0e2f5a"
              :headers="headerSNRHorz"
              :items="SNR_HORIZ"
              alternating
              show-index
              hide-footer
            >
              <template #item-horizontal="item">
                <v-row
                  justify="space-between"
                  style="align-items: center !important"
                >
                  <v-col cols="2" class="pa-0"
                    ><span> {{ item.horizontal }} </span></v-col
                  >
                  <v-col cols="10" class="pa-0 pr-6">
                    <v-progress-linear
                      :model-value="100"
                      height="10"
                      striped
                      :color="
                        item.horizontal <= 15
                          ? '#FF0000'
                          : item.horizontal <= 20
                          ? '#FFEE00'
                          : '#00FF00'
                      "
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </template>
              <template #item-ip="item">
                <v-btn
                  color="blue"
                  variant="plain"
                  @click="showDialog(item.ip, item.name, item.tipo)"
                >
                  {{ item.ip }}
                </v-btn>
              </template>
            </EasyDataTable>
            <v-sheet class="text-center mt-6" color="transparent" v-else>
              <Prog_circular />
            </v-sheet>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
  <!-- DIALOG COMPONENT -->
  <v-dialog v-model="dialog" width="85%">
    <DialogComponent
      :ip="selectedIp"
      :typeSel="selectedType"
      :name="selectedName"
      @dialog="closeDialog"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch, Ref, computed } from "vue";
import axios from "axios";

import html2pdf from "html2pdf.js";

/********************************
 ********** COMPONENTES *********
 *******************************/
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import ColumnChart from "@/components/SmartLink/charts/ColumnChart.vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay, useTheme } from "vuetify";
const theme = useTheme();
const { smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

const projectName = computed(() => store.state.projectName);
const USER = computed(() => store.state.sesion )
const ROL = computed(() => USER.value.rol)

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import {
  VISIBLE_PAGES,
  STRING_GENERAL,
  TOKEN,
  NAME_PROJECT,
  LABELS,
} from "@/constants/labels";
import { FINAL_HEADERS_TABLE } from "@/constants/tableHeaders";
import { TIMEOUTTIME, APIS_REPORT } from "@/constants/apis";
import CONSTAPIS from "@/constants/apis";

/********************************
 ********** INTERFACES **********
 *******************************/
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { ALIGN } from "@/interfaces/SmartLink/Topology";
import { SNR } from "@/interfaces/SmartLink/KPI";

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from "@/functions/errors";

const showInfo = ref(false);

/**
 * El tipo de la familia que se selecciona en el SELECT junto con el DATEINI - DATEFIN
 */
const familyType = ref("");

/**
 * La fecha inicial para el petido a la API
 */
const dateini = ref("");

/**
 * La fecha final para el petido a la API
 */
const datefin = ref("");

/**
 * Variable para mostrar la tabla de Latencia, se oculta por completo si no hay DATOS desde la API
 */
const showTenLAT = ref(true);

/**
 * Variable para mostrar la tabla de Quality LAP (RxLvl y AVG), se oculta por completo si no hay DATOS desde la API
 */
const showQualityLap = ref(true);

/**
 * Variable para mostrar la tabla de SNR H, se oculta por completo si no hay DATOS desde la API
 */
const showQualitySNRV = ref(true);

/**
 * Variable para mostrar la tabla de SNR V, se oculta por completo si no hay DATOS desde la API
 */
const showQualitySNRH = ref(true);
const cantOK: Ref<number[]> = ref([]);
const cantALARM: Ref<number[]> = ref([]);
const cantALERT: Ref<number[]> = ref([]);
const cantDOWN: Ref<number[]> = ref([]);
const arrayIPs: Ref<string[]> = ref([]);

const operability: Ref<SNR[]> = ref([]);
const qualityLap: Ref<any[]> = ref([]);
const latencyTen: Ref<EQUIPAMENTS[]> = ref([]);
const SNR_VERTI: Ref<SNR[]> = ref([]);
const SNR_HORIZ: Ref<SNR[]> = ref([]);


const headerQualLap = ref();
const headerSNRVert = ref();
const headerSNRHorz = ref();
const headerOperabi = ref();
const headerTenOperabi = ref();

/**
 * Realiza 4 peticiones a la API por orden
 * (operatividad, latencia, qualitylap y qualitysnr).
 * Se capturan también los Headers de cada tabla
 */
const getItems = async () => {
  // Capturamos el valor de AVG del HEADER de QUALITY SNR, ya que el header es el mismo, excepto por este valor
  let avgHeader = {
    text: computed(() => t("labels.avgpower")),
    value: "avgpower",
    sortable: true,
  };

  // Capturamos el HEADER de qualityLAP y agregamos al final el avgHEADER obtenido anteriormente
  headerQualLap.value = FINAL_HEADERS_TABLE[
    VISIBLE_PAGES.quality_lap
  ].toSpliced(4, 0, avgHeader);

  // Capturamos el HEADER de qualitySNR y se elimina el valor de snr_h o snr_v, dependiendo de lo que requiera la tabla
  headerSNRVert.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.quality_snr].filter(
    (head) => head.value !== "snr_h",
  );
  headerSNRHorz.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.quality_snr].filter(
    (head) => head.value !== "snr_v",
  );

  // Capturamos el HEADER de latency y se elimina el valor de fecha
  headerTenOperabi.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.latency].filter(
    (head) => head.value !== "fecha",
  );

  headerOperabi.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.operability];

  operability.value = [];
  qualityLap.value = [];
  latencyTen.value = [];
  SNR_VERTI.value = [];
  SNR_HORIZ.value = [];
  cantOK.value = [];
  cantALARM.value = [];
  cantALERT.value = [];
  cantDOWN.value = [];
  arrayIPs.value = [];
  showInfo.value = true;

  let params = {
    dateini: dateini.value,
    datefin: datefin.value,
    ip: "1",
    tipo: VISIBLE_PAGES.report,
    macType: familyType.value,
  };

  /**
   * Obtiene valores de Operatividad de la API: "getWorstOperability"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.operability, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      let allData = res.data;
      let finalArray: SNR[] = [];
      await allData.forEach((elem: SNR) => {
        let cantTotal =
          (elem.ok ?? 0) +
          (elem.alarm ?? 0) +
          (elem.alert ?? 0) +
          (elem.down ?? 0);
        let finalItem = {
          ip: elem.ip,
          name: elem.name,
          tipo: elem.tipo,
          ok: parseFloat((((elem.ok ?? 0) / cantTotal) * 100).toFixed(2)),
          alert: parseFloat((((elem.alert ?? 0) / cantTotal) * 100).toFixed(2)),
          alarm: parseFloat((((elem.alarm ?? 0) / cantTotal) * 100).toFixed(2)),
          down: parseFloat((((elem.down ?? 0) / cantTotal) * 100).toFixed(2)),
        };
        finalArray.push(finalItem);
      });

      //ordena por la cantidad de alarmas y solo capturamos las 10 primeras
      finalArray.sort((a: SNR, b: SNR) => (b.alarm ?? 0) - (a.alarm ?? 0));
      let finalData = finalArray.slice(0, 10);

      operability.value = finalData;
      operability.value.forEach((item: SNR) => {
        cantOK.value.push(item.ok ?? 0);
        cantALARM.value.push(item.alert ?? 0);
        cantALERT.value.push(item.alarm ?? 0);
        cantDOWN.value.push(item.down ?? 0);
        arrayIPs.value.push(item.name ?? "");
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });

  /**
   * Obtiene valores de Latencia de la API: "getTENWorstLatency"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.tenlatency, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      showTenLAT.value = true;

      let allData = res.data;
      if (allData.length > 0) {
        showTenLAT.value = true;
        let totalData = allData.sort(
          (a: EQUIPAMENTS, b: EQUIPAMENTS) => (b.lat ?? 0) - (a.lat ?? 0),
        ); //ordena por la latencia
        latencyTen.value = totalData;
      } else {
        showTenLAT.value = false;
      }
    })
    .catch(function (error) {
      showTenLAT.value = false;
      showConsoleError(error);
    });
  /* eslint-disable */

  /**
   * Obtiene valores de qualitylap de la API: "getWorstQualityLAP"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.qualitylap, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      showQualityLap.value = true;

      let finalArray: SNR[] = [];
      let allData = res.data;
      let allRADIO: any = {};
      let allAVG: any = {};
      let RADIOrx = 0;
      let AVGtx = 0;
      if (allData.length > 0) {
        allData.forEach((elem: any) => {
          if (
            projectName.value === NAME_PROJECT.cananea ||
            projectName.value === NAME_PROJECT.hcg ||
            projectName.value === NAME_PROJECT.nacozari
          ) {
            // Convierte a JSON la variable "snr"
            // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
            // Se aumentó PER : 0, por MIMOSA en Cananea
            allRADIO = JSON.parse(elem.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            RADIOrx =
              (typeof allRADIO["H"]).toUpperCase() == "OBJECT" &&
              allRADIO["H"] !== null
                ? allRADIO["H"][1]
                : allRADIO["H"];

            AVGtx = allRADIO["PER"];
          } else {
            // Convierte a JSON la variable "link_radio"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allRADIO = JSON.parse(elem.link_radio ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            RADIOrx =
              (typeof allRADIO["rx"]).toUpperCase() == "OBJECT" &&
              allRADIO["rx"] !== null
                ? allRADIO["rx"][0]
                : allRADIO["rx"];

            // Convierte a JSON la variable "avgpower"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allAVG = JSON.parse(elem.avgpower ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            AVGtx =
              (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
              allAVG["tx"] !== null
                ? allAVG["tx"][0]
                : allAVG["tx"];
          }

          let finalItem: SNR = {
            fecha: elem.fecha,
            name: elem.name,
            ip: elem.ip,
            tipo: elem.tipo,
            avgpower: AVGtx ?? 0,
            link_radio_rx: RADIOrx ?? 0,
          };

          finalArray.push(finalItem);
        });
        if (familyType.value === "Distribucion") {
          finalArray = finalArray.filter(
            (item: SNR) => item.subtipo !== "Distribución",
          );
        }
        let finalData = finalArray.slice(0, 5);
        qualityLap.value = finalData;
        showQualityLap.value = true;
      } else {
        showQualityLap.value = false;
      }
    })
    .catch(function (error) {
      showQualityLap.value = false;
      showConsoleError(error);
    });

  /**
   * Obtiene valores de qualitylap de la API: "getWorstQualitySNR"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.qualitysnr, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      let allData = res.data;
      let finalArray_VER: SNR[] = [];
      let finalArray_HOR: SNR[] = [];
      let allSNR: any = {};
      let allAVG: any = {};
      let SNRV = 0;
      let SNRH = 0;
      let AVGtx = 0;

      allData.forEach((elem: ALIGN) => {
        // Convierte a JSON la variable "snr"
        // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
        // Se aumentó PER : 0, por MIMOSA en Cananea
        allSNR = JSON.parse(elem.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

        // Si es Cananea, el valor está en el index 3 del array, si es otro proyecto, será el primer valor
        let indexNumber =
          projectName.value === NAME_PROJECT.cananea ||
          projectName.value === NAME_PROJECT.demo ||
          projectName.value === NAME_PROJECT.nacozari
            ? 3
            : 0;

        // Como trae valores simples o en un array, primero se valida
        // Si existe y si es un objeto (un array), se captura el primer valor del array,
        // Caso contrario se coloca el valor único que tiene
        SNRV =
          (typeof allSNR["V"]).toUpperCase() == "OBJECT" && allSNR["V"] !== null
            ? allSNR["V"][indexNumber]
            : allSNR["V"];
        SNRH =
          (typeof allSNR["H"]).toUpperCase() == "OBJECT" && allSNR["H"] !== null
            ? allSNR["H"][indexNumber]
            : allSNR["H"];

        // Convierte a JSON la variable "avgpower"
        // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx": 0}"
        allAVG = JSON.parse(elem.avgpower ?? `{"tx": 0, "rx":0}`);

        // Como trae valores simples o en un array, primero se valida
        // Si es Cananea, Captura el valor de PER del SNR, si es otro proyecto, valida
        // si existe y si es un objeto (un array), se captura el primer valor del array,
        // Caso contrario se coloca el valor único que tiene
        AVGtx =
          projectName.value === NAME_PROJECT.cananea ||
          projectName.value === NAME_PROJECT.demo ||
          projectName.value === NAME_PROJECT.nacozari
            ? allSNR["PER"]
            : (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
              allAVG["tx"] !== null
            ? allAVG["tx"][0]
            : allAVG["tx"];

        let finalItemSNRH: SNR = {
          fecha: elem.fecha ?? "",
          name: elem.name ?? "",
          ip: elem.ip ?? "",
          snr_h: SNRH ?? 0,
          tipo: elem.tipo ?? "",
          subtipo: elem.subtipo ?? "",
          avgpower: AVGtx ?? 0,
        };

        let finalItemSNRV: SNR = {
          fecha: elem.fecha ?? "",
          name: elem.name ?? "",
          ip: elem.ip ?? "",
          snr_v: SNRV ?? 0,
          tipo: elem.tipo ?? "",
          subtipo: elem.subtipo ?? "",
          avgpower: AVGtx ?? 0,
        };

        finalArray_VER.push(finalItemSNRV);
        finalArray_HOR.push(finalItemSNRH);
      });

      if (familyType.value === "Distribucion") {
        finalArray_VER = finalArray_VER.filter(
          (item: SNR) => item.subtipo !== "Distribución",
        );
        finalArray_HOR = finalArray_HOR.filter(
          (item: SNR) => item.subtipo !== "Distribución",
        );
      }
      // Ordena los Valores snr_v y snr_h de mayor a menor, luego captura los 5 primeros
      finalArray_VER.sort((a: SNR, b: SNR) => (a.snr_v ?? 0) - (b.snr_v ?? 0));
      finalArray_HOR.sort((a: SNR, b: SNR) => (a.snr_h ?? 0) - (b.snr_h ?? 0));
      let finalData_VER = finalArray_VER.slice(0, 5);
      let finalData_HOR = finalArray_HOR.slice(0, 5);

      SNR_VERTI.value = finalData_VER;
      SNR_HORIZ.value = finalData_HOR;

      SNR_VERTI.value.length > 0
        ? (showQualitySNRV.value = true)
        : (showQualitySNRV.value = false);
      SNR_HORIZ.value.length > 0
        ? (showQualitySNRH.value = true)
        : (showQualitySNRH.value = false);
    })
    .catch(function (error) {
      showQualitySNRV.value = false;
      showQualitySNRH.value = false;
      showConsoleError(error);
    });
};

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp = ref("");

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName = ref("");

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType = ref("");

/**
 * Captura (ip, tipo, nombre) y lo almacena en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística
 * del equipo en cuestión
 * @param ip IP del equipo Seleccionado
 * @param name Nombre del equipo Seleccionado
 * @param type Tipo del equipo Seleccionado
 */
const showDialog = (ip: string, name: string, type: string) => {
  selectedIp.value = ip;
  selectedName.value = name;
  selectedType.value = type;
  dialog.value = true;
};

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 * @param value valor FALSO
 */
const closeDialog = (value: boolean) => {
  dialog.value = value;
};

/**
 * Si hay un cambio de fecha inicial o final, se ocultará toda la info
 */
watch(dateini, () => {
  showInfo.value = false;
});
watch(datefin, () => {
  showInfo.value = false;
});


const exportToPdf = () => {
  // Elemento HTML que envuelve los reportes
  const element = document.getElementById("reportPDFid");

  // Opciones de configuración del PDF
  const options = {
    margin: [10, 10, 10, 10], // top, left, bottom, right (en mm)
    filename: `Reporte_${familyType.value || "General"}_${dateini.value}_${datefin.value}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2, // Mayor resolución para los gráficos y tablas
      useCORS: true, // Para permitir la carga de imágenes externas si las hay
      scrollY: 0,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "landscape", // "landscape" o "portrait" según tu preferencia
    },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  // Generar y descargar el documento
  html2pdf().set(options).from(element).save();
};

const generarReporte = () => {
   axios
    .get(APIS_REPORT.value.generarReporte, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      if(res.status === 200) {
        store.commit("showSnackBar", {
          type: LABELS.edit,
          msg: 'Se generó el reporte',
          valor: true,
        });
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
}

const enviarReporte = () => {
  axios
    .get(APIS_REPORT.value.enviarReporte, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      if(res.status === 200) {
        store.commit("showSnackBar", {
          type: LABELS.add,
          msg: 'Se envió el reporte',
          valor: true,
        });
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
}
</script>

<style>
.dateTitle {
  font-size: 20px !important;
}
.dateTitleSM {
  font-size: 12px !important;
}

.divider_color {
  color: #aab3b3 !important;
}

.textDisable {
  font-size: 11px;
  font-weight: bold;
  color: white !important;
}

.reportIMG {
  visibility: hidden;
  position: absolute;
  top: 10px;
}

.rowtitle {
  position: relative;
}

* {
  print-color-adjust: exact !important;
}

@media print {
  @page {
    size: A4;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    margin: 0;
  }

  body::before {
    content: none;
  }

  .rowBtnsMap {
    display: none;
  }

  .graphColumn3D {
    height: 470px !important;
  }

  .titleReport {
    margin-left: 42px;
  }

  .reportIMG {
    visibility: visible;
    margin-right: 12px;
  }

  .rowtitle {
    margin-top: 30px !important;
    margin-bottom: 0px !important;
  }

  .defaultCard.cardReport {
    border: none !important;
  }

  .colreport,
  .colreport2,
  .colreport3,
  .colreport4,
  .colreport5 {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .colreport3 {
    margin: 160px 0px 25px 0px !important;
    padding: 0px !important;
  }

  .colreport6 {
    margin-top: 120px !important;
  }

  .highcharts-container.highcharts-3d-chart {
    width: 100% !important;
  }

  .highcharts-container.highcharts-3d-chart {
    height: 550px !important;
    width: 100% !important;
  }
  /* 
    .colreport5, .card5 {
        margin-bottom: 40px !important;
    } */

  .home-styles {
    background-color: white !important;
  }
}
</style>
